import { usePortalName } from './usePortalName';

export function useAllowPassengerCreation(): boolean {
  // TODO: this is temporary until we get client level feature flags. We are disabling
  //       passenger creation for Alignment Healthcare for now
  const portalName = usePortalName();
  let allowCreation = true;
  if (portalName === 'ahc' || portalName === 'ahcadmin') {
    allowCreation = false;
  }
  return allowCreation;
}
